import { useParams } from "react-router-dom";
import { useUsers } from "@/hooks/User";
import React, { useEffect, useState } from "react";
import api from "@/api/axios";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { API } from "@/App";

function PersonPage() {
    const { uid } = useParams();
    const users = useUsers();
    const [stats, setStats] = useState(null);
    const me = users.find(u => u.id === uid);
    useEffect(() => { api.get(`${API}/users/${uid}/stats`).then(x => setStats(x.data)).catch(() => setStats(null)); }, [uid]);
    return (
        <div className="page">
            <div className="page-header"><div><h1>{me ? me.name : 'Member'} — {me?.job_title || '—'}</h1><p>Joined: {me?.join_date || '—'} • Email: {me?.email}</p></div></div>
            <Card><CardHeader><CardTitle>Workload</CardTitle></CardHeader><CardContent>{stats ? (<div className="kpis"><div className="kpi">Total Hours<div className="kpi-v">{stats.total_hours}</div></div><div className="kpi">Last Year<div className="kpi-v">{stats.last_year_hours}</div></div><div className="kpi">Last Month<div className="kpi-v">{stats.last_month_hours}</div></div></div>) : <div>No data</div>}</CardContent></Card>
            <Card className="mt-4"><CardHeader><CardTitle>Projects</CardTitle></CardHeader><CardContent><Table><TableHeader><TableRow><TableHead>Code</TableHead><TableHead>Name</TableHead><TableHead>Hours</TableHead></TableRow></TableHeader><TableBody>{(stats?.projects || []).map(p => (<TableRow key={p.project_id}><TableCell>{p.code}</TableCell><TableCell>{p.name}</TableCell><TableCell>{p.hours}</TableCell></TableRow>))}{(stats?.projects || []).length === 0 && (<TableRow><TableCell colSpan={3}>No projects.</TableCell></TableRow>)}</TableBody></Table></CardContent></Card>
        </div>
    );
}

export default PersonPage;